"use strict";
/*
    <copyright file="index.tsx" company="Top365">
    Copyright (c) Top365. All rights reserved.
    </copyright>
*/
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var react_router_dom_1 = require("react-router-dom");
var App_1 = require("./App");
ReactDOM.render(React.createElement(react_router_dom_1.BrowserRouter, null,
    React.createElement(App_1.default, null)), document.getElementById("root"));
//# sourceMappingURL=index.js.map